import React from "react";
import Fa from 'react-fontawesome'
import DisplayInfo from './DisplayInfo'
export default class DeviceInfoPanel extends React.Component {

  render() {
    let device = this.props.data
    let avTags = device.tags.split(',').map((item,i) => <div className='tagspan' key={i}> <Fa name='tag'/> {item} </div>)
    let  member
    

    return (

      <div className="col-md-4">
          <h4>PicoSign</h4>
          <hr/>

          <div style={{marginTop: 20, marginBottom: 20, overflowX: 'auto'}}>
              <b>{device.description}</b>
          </div>
          <div className="row">
              <div className="col-md-12">
              {avTags}
              </div>
          </div>
          <div className="row"><div className="col-md-12">{member}</div></div>
          <div style={{marginBottom: 20}}>
              <h4>{device.displays.length > 1 ? 'Displays' : 'Display'}</h4>
              <hr/>
              <DisplayInfo displays={device.displays} device={device.device_id}/>
          </div>
                          
  </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DeviceInfoPanel.js